import { CustomTabs } from '@atbay/cyber-components'
import { useMemo } from 'react'
import {
    FlexAll,
    TabsRoutingContainer,
    TabsRoutingTabLabel,
} from './index.styles'
import { useTabsRouting } from './useTabsRouting'

interface Props {
    tabList: TTabsList
    tabsName?: string
}

const TabsRouting = ({ tabList, tabsName }: Props) => {
    const { activeTab, handleTabClick, visibleTabs, theme } = useTabsRouting({
        tabList,
    })

    const items = useMemo(
        () =>
            visibleTabs.map(({ tabTitle, path, id }) => ({
                key: path,
                label: (
                    <span data-testid={id ?? tabTitle}>
                        <TabsRoutingTabLabel
                            variant="m-regular"
                            active={activeTab === path}
                            activeColor={theme.colors.greys[800]}
                            inactiveColor={theme.colors.greys[600]}
                        >
                            {tabTitle}
                        </TabsRoutingTabLabel>
                    </span>
                ),
            })),
        [visibleTabs, activeTab, theme]
    )

    return (
        <TabsRoutingContainer data-testid={tabsName ?? ''}>
            <FlexAll>
                <CustomTabs
                    activeKey={activeTab}
                    items={items}
                    onTabChange={handleTabClick}
                />
            </FlexAll>
        </TabsRoutingContainer>
    )
}

export default TabsRouting
